import { Fragment, useContext, useEffect, useState } from 'react';
import axiosInstance from '../../services/axios/axios';

import { CSS_CLASSES } from './_constants';
import classes from './AccountStatus.module.scss';
import StyleAuxiliary from '../../hoc/Auxiliary/StyleAuxiliary/StyleAuxiliary';
import { Headline6 } from '../../components/UI/MDC/Typography/Typography';
import { HomeButton } from '../../components/UI/Input/Button/index';
import { UserContext } from 'context/User/UserContext';
import { DataTable } from '../../components/UI/MDC/DataTable/DataTable';
import Base from '../Base/Base.js';

import { nanoid } from 'nanoid';

const AccountStatus = props => {
	/**
	 * @type {import('context/User/UserContext').ContextUser}
	 */
	const contextUser = useContext(UserContext);
	const user = contextUser.userInfo.impersonationProfile ?? contextUser.userInfo.userProfile;
	const [accounts, setAccounts] = useState([]);
	const [loaded, setLoaded] = useState(false);

	useEffect(() => {
		if (user?.ID) {
			axiosInstance
				.get('api/AccountStatus', {
					params: {
						esoID: user.ID,
					},
				})
				.then(response => {
					setAccounts(response.data);
				})
				.catch(error => {
					console.log('unsuccessful:', error);
				});
			setLoaded(true);
		}
	}, [user]);

	const generatedRows = accounts => {
		let rows = [];

		accounts.forEach(ac => {
			rows.push({
				Cells: {
					Application: {
						Value: ac.f_full,
						Validation: {
							Key: 'true',
						},
					},
					Username: {
						Value: ac.f_username,
						Validation: {
							Key: 'true',
						},
					},
				},
				Key: nanoid(),
			});
		});
		return rows;
	};

	const renderRoles = () => {
		const tableHeaders = [{ Value: 'Application' }, { Value: 'Username' }];

		return (
			<DataTable
				headers={tableHeaders}
				rows={generatedRows(accounts)}
				areRowsLazyLoaded
			/>
		);
	};

	return (
		<Fragment>
			<Base title={'UPMC Computer Accounts'} loading={!loaded}>
				<StyleAuxiliary classes={classes[CSS_CLASSES.CONTAINER]}>
					<Headline6>
						This page displays the usernames for your UPMC computer
						accounts.
					</Headline6>
				</StyleAuxiliary>

				{renderRoles()}

				<StyleAuxiliary classes={classes[CSS_CLASSES.TITLE_HOME]}>
					<HomeButton icon />
				</StyleAuxiliary>
			</Base>
		</Fragment>
	);
};

export default AccountStatus;
